var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C7.589 22 4 18.411 4 14V7.65C4 4.535 6.535 2 9.65 2C12.765 2 15.3 4.535 15.3 7.65V13.844C15.3 15.69 13.798 17.192 11.953 17.192C10.107 17.192 8.605 15.69 8.605 13.844V7.999C8.605 7.446 9.053 6.999 9.605 6.999C10.157 6.999 10.605 7.446 10.605 7.999V13.844C10.605 14.587 11.21 15.192 11.953 15.192C12.696 15.192 13.3 14.587 13.3 13.844V7.65C13.3 5.638 11.663 4 9.65 4C7.637 4 6 5.638 6 7.65V14C6 17.309 8.691 20 12 20C15.309 20 18 17.309 18 14V4.881C18 4.328 18.448 3.881 19 3.881C19.552 3.881 20 4.328 20 4.881V14C20 18.411 16.411 22 12 22Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.5832bc68fd6305eb5889ab9277a80242.svg";
export { ForwardRef as ReactComponent };